export default __webpack_public_path__ + "static/media/code.405af1bf.png";